<template>
  <div>
    <div v-if="smileyType === 'happy'">
      <img src="../assets/img/happy3-default.svg" v-show="!toggled">
      <img src="../assets/img/happy3-selected.svg" v-show="toggled">
    </div>
    <div v-if="smileyType === 'neutral'">
      <img src="../assets/img/happy2-default.svg" v-show="!toggled">
      <img src="../assets/img/happy2-selected.svg" v-show="toggled">
    </div>
    <div v-show="smileyType === 'sad'">
      <img src="../assets/img/happy1-default.svg" v-show="!toggled">
      <img src="../assets/img/happy1-selected.svg" v-show="toggled">
    </div>
  </div>
</template>

<script>
  export default {
    props: ['smileyType', 'userid', 'initialValue'],
    name: "happy-meter-smileys",
    data(){
      return {
        toggled: false
      }
    },
    created: function () {
      let vm = this;
      this.toggled = this.revertHappiness(this.initialValue) === this.smileyType;
      this.$parent.$on('happyMeterToggle', function (data) {
        if(data.userid === vm.userid){
          vm.toggled = data.toggles[vm.smileyType];
        }
      });
    },
    methods: {
      revertHappiness: function (val) {
        let labels = ['sad', 'neutral', 'happy'];
        return labels[val - 1];
      }
    }

  }
</script>

<style scoped>
  img{
    cursor: pointer;
  }
</style>

<!-- niet nodig

  input[type=radio].face:checked + label.face-label {
    -webkit-background-size: 100%;
    background-size: 100%;
  }

  label.face-label {
    -webkit-background-size: 100%;
    background-size: 100%;
  } -->



// WEBPACK FOOTER //
// src/components/HappyMeterSmileys.vue